module.exports = __webpack_public_path__ + "static/media/bus_service_icon_yellow.d05457a7.svg";